import { useClientHandle } from '@urql/vue';
import useUrqlUpdate from 'ui/hooks/useUrqlUpdate';

import {
  LogoutManageMyAccountDocument as Document,
  type LogoutManageMyAccountMutation as Mutation,
  type LogoutManageMyAccountMutationVariables as Variables,
} from '../../generated/graphql';



export const useMmaLogout = (onSuccess: () => void) => {
  const { onSubmitUrql, fetching } = useUrqlUpdate<Mutation, Variables>(
    useClientHandle('urql-web'),
    Document,
    'logoutManageMyAccount',
  );
  const success = ref(false);
  const onLogout = () => onSubmitUrql({ }, {
    onSuccess: () => {
      success.value = true;
      onSuccess();
    },
  });

  return {
    success,
    onLogout,
    fetching,
  };
};
